import _ from 'underscore';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import { queryify } from '@bingads-webui/url-util';

export const getBulkErrorsLogMessage = (bulkErrors) => {
  let message = 'BulkUpsert Errors: ';
  _.each(bulkErrors, (errorObj) => {
    message += `${errorObj.Error} `;
  });

  return message;
};

export const generateNameSuggestionSuffix = (prefix) => {
  let name = '';
  const today = new Date();

  const addz = function (n) {
    if (n < 10) {
      return `0${n}`;
    }
    return `${n}`;
  };

  const time = `${addz(today.getHours())}${addz(today.getMinutes())}${addz(today.getSeconds())}`;
  name = `${addz(today.getMonth() + 1)}${addz(today.getDate())}${today.getFullYear().toString().slice(2)}`;
  name = `${prefix}_${name}_${time}`;
  return name;
};

/**
 * Creates a criterion from the selected target
 * Target has a information enough to create a criteiron.
 * @private
 *
 * @param {string} criterionType - criterionType ex) Age, Gender
 * @param {string} target - criterion target ex) ThirtyFiveToFifty
 * @returns {object} criterion object
 */
export const createCriterion = (criterionType, target) => {
  const criterion = {
    Type: criterionType,
    BidAdjustment: 0,
  };

  // type target is Target except for the Device being DeviceName
  const criterionTypeTarget = criterionType === 'Device' ? 'DeviceName' : 'Target';

  criterion[`${criterionType}Criterion`] = {};
  criterion[`${criterionType}Criterion`][`${criterionTypeTarget}`] = target;

  return {
    CriterionType: criterionType,
    Criterion: criterion,
  };
};

export const getProductData = ({
  campaignId, salesCountry, getCategoryFullData,
  getProductTypeFullData, feedLabel, getCampaignCriterionsOnly,
} = {}) => {
  const state = DependencyResolver.get('component/state/index');

  let url = queryify('/Campaign/NewCampaign/GetProductScope', {
    aid: state.get('account_id'),
    cid: state.get('customer_id'),
    uid: state.get('user_id'),
  });

  let bypassCache = false;
  let cacheResponse = true;

  const extraParam = {};

  if (salesCountry) {
    extraParam.salesCountry = salesCountry;
  }

  if (getCategoryFullData) {
    extraParam.getCategoryFullData = getCategoryFullData;
  }

  if (getProductTypeFullData) {
    extraParam.getProductTypeFullData = getProductTypeFullData;
  }

  if (feedLabel) {
    extraParam.feedLabel = feedLabel;
  }

  if (getCampaignCriterionsOnly) {
    extraParam.getCampaignCriterionsOnly = getCampaignCriterionsOnly;
  }

  if (campaignId) {
    url = queryify(url, {
      campaignId,
      ...extraParam,
    });
    bypassCache = true;
    cacheResponse = false;
  }

  const params = {
    url,
    adapter: 'legacy',
    bypassCache,
    cacheResponse,
  };

  const jsdata = DependencyResolver.get('component/js-data-campaign/index');

  return jsdata.Product.find('MetaData', params);
};

export const getAudienceCreationPath = () => {
  const path = window.location.pathname.split('/').pop();
  return path;
};
